import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Signout from "./Signout";

const DevMenu = ({ resizeMenu, setResizeMenu }) => {
  const [smMenu, setSmMenu] = useState(false);
  const handleClick = () => {
    setResizeMenu(!resizeMenu);
  };

  const smClick = () => {
    setSmMenu(!smMenu);
  };

  return (
    <div>
      <div onClick={smClick} className="dashmenu-sm">
        <i
          class={`fas fa-bars font-medium mr-2 pointer ${
            smMenu ? "text-white" : ""
          }`}></i>
      </div>
      <div className={`left ${smMenu ? "smmaxmenu" : "smminmenu"}`}>
        <div
          style={{ whiteSpace: "nowrap" }}
          className="position-relative mb-4 px-25">
          <i
            onClick={handleClick}
            class="fas fa-bars text-white font-normal hamlg pointer"></i>
          <a
            className="font-medium font-weight-bold ml-3"
            style={{ color: "#fff" }}
            href="/">
            wedevelopers
          </a>
          <p className="role">developer</p>
        </div>
        <div className="mb-5">
          <div style={{ whiteSpace: "nowrap" }} className="mt-1">
            <NavLink
              activeClassName="font-weight-bolder font-normal"
              className="py-1 px-25 d-block font-normal"
              style={{ color: "#fff" }}
              to="/developer/dashboard">
              <i class="fas fa-th-large mr-2"></i> Dashboard
            </NavLink>
          </div>
          <div style={{ whiteSpace: "nowrap" }}>
            <NavLink
              activeClassName="font-weight-bolder font-normal"
              className="py-1 px-25 d-block font-normal"
              style={{ color: "#fff" }}
              to="/developer/jobs">
              <i class="fas fa-coins mr-2"></i> Jobs
            </NavLink>
          </div>
          <div style={{ whiteSpace: "nowrap" }}>
            <NavLink
              activeClassName="font-weight-bolder font-normal"
              className="py-1 px-25 d-block font-normal"
              style={{ color: "#fff" }}
              to="/developer/applications">
              <i class="far fa-bookmark mr-2"></i> Applications
            </NavLink>
          </div>
          <div style={{ whiteSpace: "nowrap" }}>
            <NavLink
              activeClassName="font-weight-bolder font-normal"
              className="py-1 px-25 d-block font-normal"
              style={{ color: "#fff" }}
              to="/developer/profile">
              <i class="fas fa-id-badge mr-2"></i> My Profile
            </NavLink>
          </div>
        </div>
        <Signout />
      </div>
      <div className={`left ${resizeMenu ? "minmenu" : "maxmenu"}`}>
        <div
          style={{ whiteSpace: "nowrap" }}
          className="position-relative mb-4 px-25">
          <i
            onClick={handleClick}
            class="fas fa-bars text-white font-normal hamlg pointer"></i>
          <a
            className="font-medium font-weight-bold ml-3"
            style={{ color: "#fff" }}
            href="/">
            wedevelopers
          </a>
          <p className="role">developer</p>
        </div>
        <div className="mb-5">
          <div style={{ whiteSpace: "nowrap" }} className="mt-1">
            <NavLink
              activeClassName="font-weight-bolder font-normal"
              className="py-1 px-25 d-block font-normal"
              style={{ color: "#fff" }}
              to="/developer/dashboard">
              <i class="fas fa-th-large mr-2"></i> Dashboard
            </NavLink>
          </div>
          <div style={{ whiteSpace: "nowrap" }}>
            <NavLink
              activeClassName="font-weight-bolder font-normal"
              className="py-1 px-25 d-block font-normal"
              style={{ color: "#fff" }}
              to="/developer/jobs">
              <i class="fas fa-coins mr-2"></i> Jobs
            </NavLink>
          </div>
          <div style={{ whiteSpace: "nowrap" }}>
            <NavLink
              activeClassName="font-weight-bolder font-normal"
              className="py-1 px-25 d-block font-normal"
              style={{ color: "#fff" }}
              to="/developer/applications">
              <i class="far fa-bookmark mr-2"></i> Applications
            </NavLink>
          </div>
          <div style={{ whiteSpace: "nowrap" }}>
            <NavLink
              activeClassName="font-weight-bolder font-normal"
              className="py-1 px-25 d-block font-normal"
              style={{ color: "#fff" }}
              to="/developer/profile">
              <i class="fas fa-id-badge mr-2"></i> My Profile
            </NavLink>
          </div>
        </div>
        <Signout />
      </div>
    </div>
  );
};

export default DevMenu;
